/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbCloudSchemaCategory {
    getFixupPrototypeFunction() { return ServiceNowCmdbCloudSchemaCategory.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbCloudSchemaCategory>): ServiceNowCmdbCloudSchemaCategory {
        let obj = Object.assign(new ServiceNowCmdbCloudSchemaCategory(), model);
        ServiceNowCmdbCloudSchemaCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbCloudSchemaCategory>): ServiceNowCmdbCloudSchemaCategory {
        if (!model) return null;
        return ServiceNowCmdbCloudSchemaCategory.newInstance(<ServiceNowCmdbCloudSchemaCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbCloudSchemaCategory) {
        if (!obj) return;

        models.ServiceNowCmdbCloudSchemaCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbCloudSchemaCategory): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbCloudSchemaCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.hierarchy) {
            for (let val of this.hierarchy) {
                models.ServiceNowCmdbResourceCategory.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Hierarchy
     */
    hierarchy: Array<models.ServiceNowCmdbResourceCategory>;

}
